import React, { useState, useEffect } from "react";
import { Spin, Empty, DatePicker } from "antd";
import { Pie } from "@ant-design/plots";
import { settlementService } from "../../../../api/enhancedApi";
import dayjs from "dayjs";

const AuditedExpensesWidget = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [date, setDate] = useState(dayjs());

    const fetchStats = async () => {
        setLoading(true);
        try {
            const year = date.year();
            const month = date.month() + 1; // dayjs month is 0-indexed
            const response = await settlementService.getAuditedExpensesStats({ year, month });
            // response.data is backend return: { year, month, items: [{ cost_type, amount }] }

            const chartData = response.data.items
                .map((item) => ({
                    type: item.cost_type,
                    value: Number(item.amount), // Ensure value is a number
                }))
                .filter((item) => item.value > 0); // Filter out zero amounts

            setData(chartData);
        } catch (error) {
            console.error("Failed to fetch audited expenses stats:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, [date]);

    const config = {
        appendPadding: 10,
        data,
        angleField: "value",
        colorField: "type",
        radius: 0.8,
        color: ["#70d8bd", "#3e4396", "#4cceac", "#ffc107", "#db4c3f", "#a4a9fc"], // Theme palette
        label: {
            text: "value",
            style: {
                fontWeight: "bold",
                fill: "#e0e0e0", // var(--text-primary)
            },
        },
        legend: {
            color: {
                title: false,
                position: "right",
                rowPadding: 5,
                itemMarker: "circle",
                itemName: {
                    style: {
                        fill: "#a3a3a3", // var(--text-secondary)
                    },
                },
            },
        },
        tooltip: {
            theme: "dark",
        },
    };

    return (
        <div style={{ height: "100%", minHeight: "300px", display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: 16, textAlign: "right" }}>
                <DatePicker picker="month" value={date} onChange={(val) => val && setDate(val)} allowClear={false} />
            </div>
            <div style={{ flex: 1 }}>
                {loading ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Spin />
                    </div>
                ) : data.length > 0 ? (
                    <Pie {...config} />
                ) : (
                    <Empty description="本月暂无已审核费用" />
                )}
            </div>
        </div>
    );
};

export default AuditedExpensesWidget;
